import React from 'react';
import { Image ,Popover,Button} from 'antd';
export const Nav30DataSource = {
  wrapper: { className: 'header3 home-page-wrapper jzih1dpqqrg-editor_css' },
  page: { className: 'home-page' },
  logo: {
    className: 'header3-logo jzjgnya1gmn-editor_css',
    children: 'https://rescr.hjiuye.com/upload/CampusRecruitment/College/logo/8fb45d67bfbb450bbef4365affcbe459.jpg',
  },
  logoTitle: {
    className: 'header3-logoTitle',
    children: '慧就业',
  },
  Menu: {
    className: 'header3-menu',
    children: [
      // {
      //   name: 'item1',
      //   className: 'header3-item',
      //   children: {
      //     href: '#',
      //     children: [{ children: <p><a href='https://enterprise.hjiuye.com/anon/register'>企业注册</a> </p>, name: 'text' }],
      //   },
      // },
      {
        name: 'item2',
        className: 'header3-item',
        children: {
          href: '#',
          children: [{ children: <p><a href='https://enterprise.hjiuye.com/user/login'>企业登录</a></p>, name: 'text' }],
        },
      },
      {
        name: 'item3',
        className: 'header3-item',
        children: {
          href: '#',
          children: [{ children: <p><a href='https://student.hjiuye.com/user/login'>学生登录</a></p>, name: 'text' }],
        },
      },
      {
        name: 'item4',
        className: 'header3-item',
        children: {
          href: '#',
          children: [{ children: <p><a href='https://college.hjiuye.com/user/login'>学校登录</a></p>, name: 'text' }],
        },
      },
      {
        name: 'item5',
        className: 'header3-item',
        children: {
          href: '#',
          children: [{ children: <p><a href='https://org.hjiuye.com/user/login'>人社登录</a></p>, name: 'text' }],
        },
      },
      {
        name: 'item6',
        className: 'header3-item',
        children: {
          href: '#',
          children: [{ children: <p><a href='https://edu.hjiuye.com/user/login'>教育厅登录</a></p>, name: 'text' }],
        },
      },
      // {
      //   name: 'item7',
      //   className: 'header3-item',
      //   children: {
      //     href: '/home/about',
      //     children: [{ children: <p><a >关于我们</a></p>, name: 'text' }],
      //   },
      // },
      // {
      //   name: 'item7',
      //   className: 'header3-item',
      //   children: {
      //     href: '#',
      //     children: [{ children: <p><a>学校咨询</a> </p>, name: 'text' }],
      //   },
      //   subItem: [
      //     {
      //       className: 'item-sub',
      //       children: {
      //         className: 'item-sub-item jzj8295azrs-editor_css',
      //         children: [
      //           {
      //             name: 'image0',
      //             className: 'item-image jzj81c9wabh-editor_css',
      //             children: <Image width={160} src='https://www.hjiuye.com/assets/img/common/wechat_contact.png'></Image>,
      //           },
      //         ],
      //       },
      //       name: 'sub~jzj8hceysgj',
      //     },
      //   ],
      // },
    ],
  },
  mobileMenu: { className: 'header3-mobile-menu' },
};
export const Nav40DataSource = {
  wrapper: { className: 'header3 home-page-wrapper jzih1dpqqrg-editor_css' },
  page: { className: 'home-page' },
  logo: {
    className: 'header3-logo jzjgnya1gmn-editor_css',
    children: 'https://resqj.hjiuye.com/styles/images/h_logo.png',
  },
  logoTitle: {
    className: 'header3-logoTitle',
    children: '慧就业',
  },
  Menu: {
    className: 'header3-menu',
    children: [
      {
        name: 'item2',
        className: 'header3-item',
        children: {
          href: '#',
          children: [{ children: <p><a href='https://enterprise.hjiuye.com/user/login'>企业登录</a></p>, name: 'text' }],
        },
      },
      {
        name: 'item3',
        className: 'header3-item',
        children: {
          href: '#',
          children: [{ children: <p><a href='https://student.hjiuye.com/user/login'>学生登录</a></p>, name: 'text' }],
        },
      },
      {
        name: 'item4',
        className: 'header3-item',
        children: {
          href: '#',
          children: [{ children: <p><a href='https://college.hjiuye.com/user/login'>学校登录</a></p>, name: 'text' }],
        },
      },
      {
        name: 'item5',
        className: 'header3-item',
        children: {
          href: '#',
          children: [{ children: <p><a href='https://org.hjiuye.com/user/login'>人社登录</a></p>, name: 'text' }],
        },
      },
      {
        name: 'item6',
        className: 'header3-item',
        children: {
          href: '#',
          children: [{ children: <p><a href='https://edu.hjiuye.com/user/login'>教育厅登录</a></p>, name: 'text' }],
        },
      },
      {
        name: 'item7',
        className: 'header3-item',
        children: {
          href: '/',
          children: [{ children: <p><a >首页</a></p>, name: 'text' }],
        },
      },
    ],
  },
  mobileMenu: { className: 'header3-mobile-menu' },
};
export const Banner50DataSource = {
  wrapper: { className: 'home-page-wrapper banner5' },
  page: { className: 'home-page banner5-page' },
  childWrapper: {
    className: 'banner5-title-wrapper',
    children: [
      { name: 'title', children: '产品名', className: 'banner5-title' },
      {
        name: 'explain',
        className: 'banner5-explain',
        children: '产品标语介绍',
      },
      {
        name: 'content',
        className: 'banner5-content',
        children: '产品的详细说明，如是什么东西之类的文字',
      },
      {
        name: 'button',
        className: 'banner5-button-wrapper',
        children: {
          href: 'https://enterprise.hjiuye.com/anon/register',
          className: 'banner5-button',
          type: 'primary',
          children: '开始使用',
        },
      },
      {
        name: 'button',
        className: 'banner5-button-wrapper',
        children: {
          href: 'https://enterprise.hjiuye.com/anon/register',
          className: 'banner5-button',
          type: 'primary',
          children: '学校咨询',
        },
      },
    ],
  },
  
  image: {
    className: 'banner5-image',
    children:
      'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*-wAhRYnWQscAAAAAAAAAAABkARQnAQ',
  },
};
export const Feature60DataSource = {
  wrapper: { className: 'home-page-wrapper feature6-wrapper' },
  page: { className: 'home-page feature6' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'feature6-title-wrapper',
    children: [
      {
        name: 'title',
        className: 'feature6-title-h1',
        children: '我们的使命',
      },
      {
        name: 'content',
        className: 'feature7-title-content',
        children: '关注每一名学生的成长与就业！',
      },
    ],
  },
  blockWrapper: {
    className: 'feature6-block-wrapper',
    // gutter: 24,
    children: [
      {
        // md: 4,
        // xs: 24,
        name: 'block0',
        className: 'feature6-block',
        children: {
          className: 'feature6-block-group',
          children: [
            {
              name: 'title',
              className: 'feature6-block-title',
              children: '赋能学校',
            },
            {
              name: 'content',
              className: 'feature6-block-content',
              children: '搭建官方5G学习与就业平台',
            },
            {
              name: 'image',
              className: 'feature6-block-image',
              children: (<Image preview={false} src="https://resqj.hjiuye.com/styles/images/product2.png"></Image>),
            },
          ],
        },
      },
      {
        // md: 4,
        // xs: 24,
        name: 'block1',
        className: 'feature6-block',
        children: {
          className: 'feature6-block-group',
          children: [

            {
              name: 'title',
              className: 'feature6-block-title',
              children: '校企在线对接',
            },
            {
              name: 'content',
              className: 'feature6-block-content',
              children: '增加100%就业机会',
            },
            {
              name: 'image',
              className: 'feature6-block-image',
              children: (<Image preview={false} src="https://resqj.hjiuye.com/styles/images/product5.png"></Image>),
            },
          ],
        },
      },
      {
        // md: 4,
        // xs: 24,
        name: 'block2',
        className: 'feature6-block',
        children: {
          className: 'feature6-block-group',
          children: [

            {
              name: 'title',
              className: 'feature6-block-title',
              children: '5G校招',
            },
            {
              name: 'content',
              className: 'feature6-block-content',
              children: '彻底打破就业地域限制',
            },
            {
              name: 'image',
              className: 'feature6-block-image',
              children: (<Image preview={false} src="https://resqj.hjiuye.com/styles/images/product1.png"></Image>),
            },
          ],
        },
      },
      {
        // md: 4,
        // xs: 24,
        name: 'block3',
        className: 'feature6-block',
        children: {
          className: 'feature6-block-group',
          children: [
            {
              name: 'title',
              className: 'feature6-block-title',
              children: '在线学习辅导',
            },
            {
              name: 'content',
              className: 'feature6-block-content',
              children: '提高学生职场竞争力',
            },
            {
              name: 'image',
              className: 'feature6-block-image',
              children: (<Image preview={false} src="https://resqj.hjiuye.com/styles/images/product4.png"></Image>),
            },
          ],
        },
      },
      {
        // md: 4,
        // xs: 24,
        name: 'block4',
        className: 'feature6-block',
        children: {
          className: 'feature6-block-group',
          children: [

            {
              name: 'title',
              className: 'feature6-block-title',
              children: 'AI与大数据',
            },
            {
              name: 'content',
              className: 'feature6-block-content',
              children: '引导学生精准就业',
            }, {
              name: 'image',
              className: 'feature6-block-image',
              children: (<Image preview={false} src="https://resqj.hjiuye.com/styles/images/product2.png"></Image>),
            },
          ],
        },
      },
    ],
  },
};

export const Feature70DataSource = {
  wrapper: { className: 'home-page-wrapper feature7-wrapper' },
  page: { className: 'home-page feature7' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'feature7-title-wrapper',
    children: [
      {
        name: 'title',
        className: 'feature7-title-h1',
        children: '全面就业信息化解决方案',
      },
      {
        name: 'content',
        className: 'feature7-title-content',
        children: '把就业办老师从繁琐的日常工作中解脱出来，让学生公平获得优质的学习资源和就业机会！',
      },
    ],
  },
  blockWrapper: {
    className: 'feature7-block-wrapper',
    gutter: 24,
    children: [
      {
        md: 6,
        xs: 24,
        name: 'block0',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image jzjgrlz134-editor_css img0',
              // children:
              //   'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: '就业管理',
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: '就业全过程管理，跟踪每一名学生的就业进展',
            },
          ],
        },
      },
      {
        md: 6,
        xs: 24,
        name: 'block1',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image jzjgrlz134-editor_css img1',
            //   children:
            //     'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
           },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: '智慧建站',
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: 'PC就业官网、校内直聘网、微信就业门户、学生就业学习小程序一体化设计，确保就业信息精准送达',
            },
          ],
        },
      },
      {
        md: 6,
        xs: 24,
        name: 'block2',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image jzjgrlz134-editor_css img2',
              // children:
              //   'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: '就业数据分析',
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: '多维度、多角度数据分析，为未来就业管理提供决策依据',
            },
          ],
        },
      },
      {
        md: 6,
        xs: 24,
        name: 'block3',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image jzjgrlz134-editor_css img3',
              // children:
              //   'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: '视频直播',
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: 'HR与学生随时随地沟通，随时随地面试，不受时间和地域限制',
            },
          ],
        },
      },
      {
        md: 6,
        xs: 24,
        name: 'block4',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image jzjgrlz134-editor_css img4',
              // children:
              //   'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: '直播招聘',
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: '彰显企业雇主品牌，真实展示企业信息，让学生更深入得了解企业',
            },
          ],
        },
      },
      {
        md: 6,
        xs: 24,
        name: 'block5',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image jzjgrlz134-editor_css img5',
              // children:
              //   'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: '网上视频招聘会',
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: '彰显企业雇主品牌，真实展示企业信息，让学生更深入得了解企业',
            },
          ],
        },
      },
      {
        md: 6,
        xs: 24,
        name: 'block6',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image jzjgrlz134-editor_css img6',
              // children:
              //   'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: '宣讲会直播',
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: '解决学生跨校区参会难题',
            },
          ],
        },
      },
      {
        md: 6,
        xs: 24,
        name: 'block7',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image jzjgrlz134-editor_css img7',
              // children:
              //   'https://gw.alipayobjects.com/zos/basement_prod/e339fc34-b022-4cde-9607-675ca9e05231.svg',
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: '就业培训与指导',
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: '充分利用社会就业辅导师资资源，满足学生碎片化学习需要',
            },
          ],
        },
      },
    ],
  },
};

export const Feature00DataSource = {
  wrapper: { className: 'home-page-wrapper content0-wrapper' },
  page: { className: 'home-page content' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [{ name: 'title', children: '多版本适配' }],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'jzjn8afnsxb-editor_css content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item jzjgrrupf2c-editor_css',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon jzjgrlz134-editor_css',
              // children:
              //   'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*CTp8T7RT-VkAAAAAAAAAAABkARQnAQ',
            },
            {
              name: 'title',
              className: 'content0-block-title jzj8xt5kgv7-editor_css',
              children: '视频直聘版',
            },
            {
              name: 'content',
              children: '校企对接，视频直聘，直播招聘，网络视频招聘会，空中宣讲，视频面试，在线学校与辅导',
              className: 'jzj8z9sya9-editor_css',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon jzjncn210ql-editor_css version2',
              // children:
              //   'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*CTp8T7RT-VkAAAAAAAAAAABkARQnAQ',
            },
            {
              name: 'title',
              className: 'content0-block-title jzjne54fwqm-editor_css',
              children: '专业版',
            },
            {
              name: 'content',
              children: '视频直聘版全部功能，就业全过程管理，网上办公，智慧建站及就业数据统计分析',
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'content0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon jzjndq0dueg-editor_css version3',
              // children:
              //   'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*CTp8T7RT-VkAAAAAAAAAAABkARQnAQ',
            },
            {
              name: 'title',
              className: 'content0-block-title jzjne24af8c-editor_css',
              children: '本地部署',
            },
            {
              name: 'content',
              children: '按需定制，部署在学校服务器',
            },
          ],
        },
      },
      // {
      //   name: 'block~jzjn87bmyc7',
      //   className: 'content0-block',
      //   md: 6,
      //   xs: 24,
      //   children: {
      //     className: 'content0-block-item',
      //     children: [
      //       {
      //         name: 'image',
      //         className: 'content0-block-icon jzjndsyw8sf-editor_css',
      //         children:
      //           'https://gw.alipayobjects.com/mdn/rms_ae7ad9/afts/img/A*CTp8T7RT-VkAAAAAAAAAAABkARQnAQ',
      //       },
      //       {
      //         name: 'title',
      //         className: 'content0-block-title jzjndw5oerk-editor_css',
      //         children: '一站式数据运营',
      //       },
      //       {
      //         name: 'content',
      //         children: '沉淀产品接入效率和运营小二工作效率数据',
      //       },
      //     ],
      //   },
      // },
    ],
  },
};
export const Feature80DataSource = {
  wrapper: { className: 'home-page-wrapper content8-wrapper' },
  page: { className: 'home-page content8' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [{ name: 'title', children: '安全服务' }],
  },
  childWrapper: {
    className: 'content8-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'jzjn8afnsxb-editor_css content8-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content8-block-item jzjgrrupf2c-editor_css',
          children: [
            {
              name: 'image',
              // className: 'content8-block-icon jzjgrlz134-editor_css',
              children:
                'https://resqj.hjiuye.com/styles/images/security1.jpg',
            }

          ],
        },
      },
      {
        name: 'block1',
        className: 'content8-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content8-block-item',
          children: [

            {
              name: 'title',
              className: 'content8-block-title jzjne54fwqm-editor_css',
              children: '系统部署',
            },
            {
              name: 'content',
              children: (<div><p>3小时完成系统部署</p><p>3-7天完成数据迁移</p><p>1-2次免费系统使用培训</p></div>),
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'content8-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content8-block-item',
          children: [
            {
              name: 'image',
              // className: 'content8-block-icon jzjndq0dueg-editor_css',
              children:
                'https://resqj.hjiuye.com/styles/images/security3.jpg',
            },
          ],
        },
      },
      {
        name: 'block3',
        className: 'content8-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content8-block-item',
          children: [
            {
              name: 'title',
              className: 'content8-block-title jzjne24af8c-editor_css',
              children: '信息安全',
            },
            {
              name: 'content',
              children: (<div><p>全方位漏洞检测，漏洞扫描及web攻击防范</p><p>数据隔离、全站传输加密</p><p>数据异地多点备份</p></div>),
            },
          ],
        },
      },
      {
        name: 'block4',
        className: 'content8-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content8-block-item',
          children: [
            {
              name: 'image',
              // className: 'content8-block-icon jzjndq0dueg-editor_css',
              children:
                'https://resqj.hjiuye.com/styles/images/security2.jpg',
            }
          ],
        },
      },
      {
        name: 'block5',
        className: 'content8-block',
        md: 8,
        xs: 24,
        children: {
          className: 'content8-block-item',
          children: [
            {
              name: 'title',
              className: 'content8-block-title jzjne24af8c-editor_css',
              children: '售后服务',
            },
            {
              name: 'content',
              children: (<div><p>系统免费升级</p><p>专属微信群提供技术支持</p><p>故障3小时恢复</p></div>),
            },
          ],
        },
      },
    ],
  },
};
export const Feature90DataSource = {
  wrapper: { className: 'home-page-wrapper feature9-wrapper' },
  page: { className: 'home-page feature9' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'feature9-title-wrapper',
    children: [
      {
        name: 'title',
        className: 'feature9-title-h1',
        children: '我们的优势',
      },
      // {
      //   name: 'contentLeft',
      //   className: 'feature9-title-content',
      //   children: '优势',
      // },
      // {
      //   name: 'contentRight',
      //   className: 'feature9-title-content',
      //   children: '详情',
      // },
    ],
  },
  blockWrapper: {
    className: 'feature9-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'feature9-block',
        children: {
          className: 'feature9-block-group',
          children: [
            {
              name: 'title',
              className: 'feature9-block-title',
              children: '模块化设计',
            },
            {
              name: 'content',
              className: 'feature9-block-content',
              children: '学校可以根据自身情况按需配置产品，全方位满足管理、学习和就业需求',
            },
            {
              name: 'image',
              className: 'feature9-block-image',
              children: (<Image preview={false} src="https://resqj.hjiuye.com/styles/images/index/problem1.png"></Image>),
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'feature9-block',
        children: {
          className: 'feature9-block-group',
          children: [

            {
              name: 'title',
              className: 'feature9-block-title',
              children: '院系深度参与',
            },
            {
              name: 'content',
              className: 'feature9-block-content',
              children: '学校、院系二级管理，院系可自行举办招聘活动并为企业推荐人才',
            },
            {
              name: 'image',
              className: 'feature9-block-image',
              children: (<Image preview={false} src="https://resqj.hjiuye.com/styles/images/index/problem2.png"></Image>),
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'feature9-block',
        children: {
          className: 'feature9-block-group',
          children: [

            {
              name: 'title',
              className: 'feature9-block-title',
              children: '5G学习与就业解决方案',
            },
            {
              name: 'content',
              className: 'feature9-block-content',
              children: '直播招聘、视频简历、企业视频介绍，视频面试、网络视频招聘会，视频培训与辅导，让学生轻松学习，轻松找到好工作',
            },
            {
              name: 'image',
              className: 'feature9-block-image',
              children: (<Image preview={false} src="https://resqj.hjiuye.com/styles/images/index/problem3.png"></Image>),
            },
          ],
        },
      },
      {
        name: 'block3',
        className: 'feature9-block',
        children: {
          className: 'feature9-block-group',
          children: [
            {
              name: 'title',
              className: 'feature9-block-title',
              children: '线上线下活动相结合',
            },
            {
              name: 'content',
              className: 'feature9-block-content',
              children: '网络视频招聘不受时间和空间限制，企业学生在线参会，大幅降低企业成本，为学生提供更多就业选择',
            },
            {
              name: 'image',
              className: 'feature9-block-image',
              children: (<Image preview={false} src="https://resqj.hjiuye.com/styles/images/index/problem4-2.png"></Image>),
            },
          ],
        },
      },
      {
        name: 'block4',
        className: 'feature9-block',
        children: {
          className: 'feature9-block-group',
          children: [

            {
              name: 'title',
              className: 'feature9-block-title',
              children: '兼顾就业、实习与兼职',
            },
            {
              name: 'content',
              className: 'feature9-block-content',
              children: '即为应届毕业生提供优质就业机会，也为所有在校学生提供实习、兼职工作机会，帮助学生完成从学生到职场的身份转化',
            }, {
              name: 'image',
              className: 'feature9-block-image',
              children: (<Image preview={false} src="https://resqj.hjiuye.com/styles/images/index/problem5.png"></Image>),
            },
          ],
        },
      },
      {
        name: 'block5',
        className: 'feature9-block',
        children: {
          className: 'feature9-block-group',
          children: [

            {
              name: 'title',
              className: 'feature9-block-title',
              children: '以学习带动就业',
            },
            {
              name: 'content',
              className: 'feature9-block-content',
              children: '丰富的就业、创业与专业技能培训与辅导，帮助学生大幅提升职场竞争力',
            }, {
              name: 'image',
              className: 'feature9-block-image',
              children: (<Image preview={false} src="https://resqj.hjiuye.com/styles/images/index/problem6.png"></Image>),
            },
          ],
        },
      },
      {
        name: 'block6',
        className: 'feature9-block',
        children: {
          className: 'feature9-block-group',
          children: [

            {
              name: 'title',
              className: 'feature9-block-title',
              children: 'AI',
            },
            {
              name: 'content',
              className: 'feature9-block-content',
              children: '自动为学生匹配就业机会和培训内容',
            }, {
              name: 'image',
              className: 'feature9-block-image',
              children: (<Image preview={false} src="https://resqj.hjiuye.com/styles/images/index/problem7.png"></Image>),
            },
          ],
        },
      },
      {
        name: 'block7',
        className: 'feature9-block',
        children: {
          className: 'feature9-block-group',
          children: [

            {
              name: 'title',
              className: 'feature9-block-title',
              children: '就业安全',
            },
            {
              name: 'content',
              className: 'feature9-block-content',
              children: '企业资质验证，企业实名验证，HR实名验证，举报体系，最大限度保证学生就业安全',
            }, {
              name: 'image',
              className: 'feature9-block-image',
              children: (<Image preview={false} src="https://resqj.hjiuye.com/styles/images/index/problem8.png"></Image>),
            },
          ],
        },
      },
    ],
  },
};
export const Carousel50DataSource = {
  wrapper: { className: 'home-page-wrapper carousel5' },
  page: { className: 'home-page carousel5-page' },
  OverPack: { playScale: 0.3 },

  blockWrapper: {
    className: 'carousel5-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'carousel5-block jzjgrlz134-editor_css img1',
        children: {
          className: 'carousel5-block-group img1',
          children: [
            { name: 'title', children: '慧就业', className: 'carousel5-block-title' },
            {
              name: 'explain',
              className: 'carousel5-block-explain',
              children: '校园5G学习与就业平台的先行者',
            },
            {
              name: 'content',
              className: 'carousel5-block-content',
              children: '就业管理 • 学习辅导 • 精准就业',
            },
         
     
            // {
            //   name: 'button-Popover',
            //   className: 'carousel5-block-button-Popover',
            //   children:(<div>
            //     <Popover placement="right"  content={<div><Image width={120} height={120} preview={false} src="https://www.hjiuye.com/styles/images/product2.png"></Image></div>}>
            //        <Button>学校咨询</Button>
            // </Popover>
 
            //   </div>),
            // }, 
            {
              name: 'image',
              className: 'carousel5-block-image',
              children:<div>
                学校咨询
                <Image width={160} preview={false} src='https://resqj.hjiuye.com/assets/img/common/wechat_contact.png'></Image>
              </div>,
            },
            {
              name: 'button-wrapper',
              className: 'carousel5-block-button-wrapper',
              children: {
                href: 'https://enterprise.hjiuye.com/anon/register',
                className: 'carousel5-block-button-wrapper-button',
                type: 'primary',
                children: '企业注册',
              },
            }, 
          ],
        },
      },
      {
        name: 'block1',
        className: 'carousel5-block1 ',
        children: {
          className: 'carousel5-block-group1 jzjgrlz134-editor_css img2',
          children: [

            { name: 'title', children: '学校', className: 'carousel5-block-title' },
            {
              name: 'explain',
              className: 'carousel5-block-explain',
              children: '持续优化和改进就业管理与服务，全面掌控学生就业',
            },
            {
              name: 'content',
              className: 'carousel5-block-content',
              children: '',
            },
            {
              name: 'button-wrapper',
              className: 'carousel5-block-button-wrapper',
              children: {
                href: 'https://enterprise.hjiuye.com/anon/register',
                className: 'carousel5-block-button-wrapper-button',
                type: 'primary',
                children: '企业注册',
              },
            }, 
            {
              name: 'image',
              className: 'carousel5-block-image ',
              // children: 'https://www.hjiuye.com/styles/images/banner4.png',
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'carousel5-block imag2',
        children: {
          className: 'carousel5-block-group2 imag2',
          children: [
            { name: 'title', children: '企业', className: 'carousel5-block-title' },
            {
              name: 'explain',
              className: 'carousel5-block-explain',
              children: '选专业对口学校，找志趣相投人才',
            },
            {
              name: 'button',
              className: 'carousel5-button-wrapper',
              children: {
                href: 'https://enterprise.hjiuye.com/anon/register',
                className: 'carousel5-block-button-wrapper-button',
                type: 'primary',
                children: '企业注册',
              },
            },
             {
              name: 'image',
              className: 'carousel5-block-image',
              // children: 'https://www.hjiuye.com/styles/images/banner4.png',
            },
          ],
        },
      },
      {
        name: 'block3',
        className: 'carousel5-block',
        children: {
          className: 'carousel5-block-group3',
          children: [
            { name: 'title', children: '学生', className: 'carousel5-block-title' },
            {
              name: 'explain',
              className: 'carousel5-block-explain',
              children: '学习就业与专业技能，轻松搞定好工作',
            },
            {
              name: 'button',
              className: 'carousel5-button-wrapper',
              children: {
                href: 'https://enterprise.hjiuye.com/anon/register',
                className: 'carousel5-block-button-wrapper-button',
                type: 'primary',
                children: '企业注册',
              },
            }, 
            {
              name: 'image',
              className: 'carousel5-block-image',
              // children: 'https://www.hjiuye.com/styles/images/banner4.png',
            },
          ],
        },
      },
    ],
  },
};
export const Footer10DataSource = {
  wrapper: { className: 'home-page-wrapper footer1-wrapper' },
  OverPack: { className: 'footer1', playScale: 0.2 },
  block: {
    className: 'home-page',
    gutter: 0,
    children: [
      {
        name: 'block3',
        xs: 24,
        md: 8,
        className: 'block',
        title: { },
        childWrapper: {
          children: [
            { href: '#', name: 'link0', children: '企业客服电话：17600673259 ' },
            { href: '#', name: 'link1', children: '商务合作：18800026128' },
            { href: '#', name: 'link2', children: '客服邮箱：service@hjiuye.com' },
          ],
        },
      },
     
      {
        name: 'block2',
        xs: 24,
        md: 12,
        className: 'block',
        title: {className: 'logo jzl0qcpyjra-editor_css',
         children: <a href="https://rcjy.ccxq.gov.cn/"><Image preview={false} style={{backgroundColor: '#fff'}} width={406} height={120} src="https://resqj.hjiuye.com/assets/img/common/ccxqrcw.png"></Image></a>,
        
        },
        childWrapper: {
          children: [
            // {
            //   name: 'image~jzl0tcm4f1d',
            //   className: 'wechat_public',
            //   children:<Image style={{backgroundColor: '#fff'}} width={320} height={120} src="https://www.hjiuye.com/assets/img/common/ccxqrcw.png"></Image>
            //     ,
            // },
            // {
            //   href: 'https://rcjy.ccxq.gov.cn/',
            //   name: 'link0',
            //   children: <p></p>,
            //   className: 'jzl0u1bko6-editor_css',
            // },
            // { href: '#', name: 'link1', children: '联系我们' },
          ],
        },
      },
      {
        name: 'block0',
        xs: 24,
        md: 4,
        className: 'block',
        title: {
          className: 'logo jzl0qcpyjra-editor_css',
          children:<Image preview={false} width={120} height={120} src="https://resqj.hjiuye.com/assets/img/common/wechat_public.png"></Image>,
        },
        childWrapper: {
          className: 'slogan',
          children: [
            { name: 'content0', children: <p>微信公众帐号</p> },
          ],
        },
      },
    ],
  },
  copyrightWrapper: { className: 'copyright-wrapper' },
  copyrightPage: { className: 'home-page' },
  copyright: {
    className: 'copyright',
    children: (
      <span>
        {/* <a href="http://abc.alipay.com">隐私权政策</a>&nbsp; &nbsp; &nbsp;
        |&nbsp; &nbsp; &nbsp; <a href="http://abc.alipay.com">权益保障承诺书</a>&nbsp; */}
        &nbsp; &nbsp;&nbsp;<Image preview={false} width={20} height={20} src='https://resqj.hjiuye.com/styles/images/index/police.png'></Image>京ICP备09082043号-1&nbsp; &nbsp;
        &nbsp;&nbsp;Copyright © 北京大都智源咨询有限公司 版权所有<br />
      </span>
    ),
  },
};
export const About00DataSource = {
  wrapper: { className: 'home-page-wrapper about0-wrapper' },
  page: { className: 'home-page conten' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [{ name: 'title', children: '分支机构' }],
  },
  childWrapper: {
    className: 'about0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'jzjn8afnsxb-editor_css about0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'about0-block-item',
          children: [
            {
              name: 'title',
              className: 'about0-block-title',
              children: '北京总部',
            },
            {
              name: 'content',
              children: '地址：北京市朝阳区北苑路媒体村1号楼1802室',
              className: 'jzj8z9sya9-editor_css',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'about0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'about0-block-item',
          children: [
            {
              name: 'title',
              className: 'about0-block-title jzjne54fwqm-editor_css',
              children: '上海分公司',
            },
            {
              name: 'content',
              children: '地址：上海市浦东新区灵山路958号融汇创意园5号楼2层',
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'about0-block',
        md: 8,
        xs: 24,
        children: {
          className: 'about0-block-item',
          children: [
            {
              name: 'title',
              className: 'about0-block-title jzjne24af8c-editor_css',
              children: '宁波分公司',
            },
            {
              name: 'content',
              children: '地址：浙江省宁波市北仑区长白山路509号人才大厦8号楼813室',
            },
          ],
        },
      },
   
    ],
  },
};
export const About60DataSource = {
  wrapper: { className: 'home-page-wrapper about6-wrapper' },
  page: { className: 'home-page about6' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'about6-title-wrapper',
    children: [
      {
        name: 'title',
        className: 'about6-title-h1',
        children: '公司介绍',
      },
      {
        name: 'content',
        className: 'about6-title-content',
        children: '公司成立于2017年7月，总部位于北京，是新一代校园智慧学习与就业解决方案供应商，公司致力于将AI、大数据和视频技术与学生学习、就业、面试场景深度结合，助力学校提升就业管理和服务水平；帮助学生利用碎片化时间，在线学习就业、创业与专业技能，提升学生的职场竞争力；通过学校、企业和学生三方精准连接、匹配与协同，视频招聘、直播招聘、网络招聘会与传统现场招聘相结合，彻底打破地域限制，大幅提高学生就业率和就业质量。！',
      },
    ],
  },
  blockWrapper: {
    className: 'about6-block-wrapper',
    // gutter: 24,
    children: [
    
    ],
  },
};
